module.exports = __webpack_public_path__ + "img/PM_A02_front_diagonal_horizontal_en.ac680748.png";